import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {useEffect, useState} from "react";
import { db } from "../../firebase";
function Statistics() {
  const [registered, setRegistered] = useState(0);
  const [backpacks, setBackpacks] = useState(0);
  const [bottles, setBottles] = useState(0);
  const [hoodies, setHoodies] = useState(0);
  const [caps, setCaps] = useState(0);
  const [shirts, setShirts] = useState(0);
  const [achievements, setAchievements] = useState(0);
  const accomplishedRef = db.collection("purchases");
  const purchases = accomplishedRef.where("received", "==", true);

  useEffect(() => {
      purchases.where('prizeId', '==', 'aII7Os0EQmNhBpd3sDd8').get().then((item) => {
          setHoodies(item.size)
      });
      purchases.where('prizeId', '==', '0nIaZYrBtBm1cnDcW4Wu').get().then((item) => {
          setBackpacks(item.size)
      });
      purchases.where('prizeId', '==', 'MH5IsRuIYfvQ4amZP1VF').get().then((item) => {
          setCaps(item.size)
      });
      purchases.where('prizeId', '==', 'RqSOEI0k85xiTSAybQr0').get().then((item) => {
          setBottles(item.size)
      });
      purchases.where('prizeId', '==', 'gDuPklGXmOgOkZZBXx89').get().then((item) => {
          setShirts(item.size)
      });

      db.collection("accomplished").where('achievementId', 'not-in', ['qgBTdSqHwHLDfwOb3e55','OEOxsCYAbRgatX4FNXfJ','BESwlZNXlQTBSfjVtJlS']).get().then((item) => {
          setAchievements(item.size)
      });
      db.collection("users")
          .get()
          .then((item) => {
              setRegistered(item.size)
          });

  }, [])



  return (
    <>
      <Container
        component="main"
        sx={{ marginTop: 2, marginBottom: 2 }}
        maxWidth="xl"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Зарегистрировалось</TableCell>
                    <TableCell align="center">Выполнение нормативов</TableCell>
                    <TableCell align="center">Бейсболка</TableCell>
                    <TableCell align="center">Футболка</TableCell>
                    <TableCell align="center">Бутылка</TableCell>
                    <TableCell align="center">Худи</TableCell>
                    <TableCell align="center">Рюкзак</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="center">{registered}</TableCell>
                    <TableCell align="center">{achievements}</TableCell>
                    <TableCell align="center">{caps}</TableCell>
                    <TableCell align="center">{shirts}</TableCell>
                    <TableCell align="center">{bottles}</TableCell>
                    <TableCell align="center">{hoodies}</TableCell>
                    <TableCell align="center">{backpacks}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Statistics;
